{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Layar Penuh",
		"achievements": "Prestasi",
		"reset": "Atur Ulang",
		"language": "Bahasa"
	},
	"achievements": {
		"title": "Prestasi",
		"noAchievements": "Belum ada prestasi yang diraih. Terus klik!",
		"unlocked": "Prestasi Terbuka: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Kelinci Pemula",
		"carrotSnatcher": "🥕 Pencuri Sayuran",
		"bunnyBerserker": "😡 Amukan Kelinci",
		"hopPunk": "🎸 Kelinci Anarkis",
		"bunnyNinja": "🥷 Kelinci Ninja Mematikan",
		"expert": "🌟 Pelompat Ahli",
		"master": "👑 Raja Wortel",
		"carrotpocalypse": "🥕 Penghancur Kebun",
		"bunnyOverlord": "😈 Penguasa Tertinggi Kelinci",
		"chaosHare": "🌪️ Agen Kekacauan",
		"carrotCultist": "⛪ Pendeta Tinggi Kultus Wortel",
		"bunnyberryPie": "🥧 Ahli Pai Halusinasi",
		"rabbitHole": "🕳️ Penggali Terowongan Kuantum",
		"moonRabbit": "🌙 Kelinci Bulan",
		"bunnyDoom": "💀 Pembawa Kiamat Kelinci",
		"carrotNuke": "☢️ Pemegang Wortel Nuklir",
		"bunnyMatrix": "🤖 Glitch dalam Matrix Kelinci",
		"cosmicHare": "🌌 Kelinci Kosmik Bangkit",
		"warrenSingularity": "🕳️ Singularitas Liang Tercapai",
		"eternalBunny": "♾️ Kelinci Abadi"
	},

	"messages": {
		"prophecy": "Ramalan klik kuno mulai terungkap...",
		"cosmic": "Para pengklik kosmik akan bangga dengan kemajuanmu!",
		"astral": "Klik-klik bergema melalui alam astral...",
		"speaking": "Tunggu... apa kamu mendengarnya? Klik-klik itu berbicara padaku...",
		"ancient": "Klikmu beresonansi dengan kekuatan kuno!",
		"sages": "Para Bijak Klik berbisik tentang potensimu...",
		"demons": "LIHATLAH! Para Iblis Klik bangkit dari tidur mereka!",
		"veil": "Klik-klikmu menembus tirai realitas!",
		"spirits": "Roh-Roh Klik menari mengikuti iramamu...",
		"council": "Dewan Agung Klik telah memperhatikan dedikasimu",
		"primordial": "Klikmu membangunkan kekuatan primordial!",
		"void": "Kekosongan klik menatap balik padamu...",
		"runes": "Rune-rune klik kuno bersinar dengan kekuatanmu!",
		"beast": "TIGA TIGA TIGA - ANGKA DARI MAKHLUK KLIK",
		"prophets": "Para Nabi Klik bernyanyi tentang kedatanganmu!",
		"dimensions": "Klik-klikmu bergema melalui dimensi...",
		"portal": "Klik-klikmu telah membuka portal ke Dimensi Klik!",
		"sacrifice": "Para Dewa Klik Kuno menuntut LEBIH BANYAK PENGORBANAN",
		"jackpot": "JACKPOT! Kasino Klik menyambut juara barunya!",
		"unmatched": "Kekuatan klikmu tak tertandingi!",
		"reality": "Realitas sendiri tunduk pada kehendak klikmu!",
		"elite": "KAMU TELAH MENJADI PENGUASA KLIK ELIT",
		"power": "Level kekuatan klikmu di atas 1500!",
		"devils": "Para Iblis Klik membungkuk di hadapan kekuatanmu",
		"lucky": "Klik keberuntungan mengalir dalam pembuluh darahmu",
		"dynasty": "Dinasti Klik mengakui supremasimu",
		"twoThousand": "Dua ribu klik kekuatan murni!",
		"quartet": "Ramalan Kuartet Klik telah terpenuhi",
		"transcend": "Klikmu melampaui pemahaman fana",
		"constellation": "Konstelasi Klik selaras untuk menghormatimu",
		"destiny": "TIGA RIBU KLIK TAKDIR",
		"triforce": "Triforce Klik Tiga terbangun!",
		"fortune": "Keberuntungan berpihak pada pengklik yang gigih",
		"newDimensions": "Kekuatan klikmu mencapai dimensi baru",
		"quartet2": "Kuartet Klik Empat mengharmonisasi",
		"threshold": "Berdiri di ambang keillahian klik",
		"ultimate": "LIMA RIBU KLIK KEKUATAN ULTIMAT!",
		"force": "Kekuatan Klik Lima Jari siap kau perintah",
		"underworld": "Dunia Bawah Klik memahkotaimu sebagai penguasa mereka",
		"maxJackpot": "JACKPOT KLIK MAKSIMUM TERCAPAI",
		"infinite": "KEKUATAN KLIK TAK TERBATAS!",
		"godhood": "KAMU TELAH NAIK MENJADI DEWA KLIK",
		"burrow": "Kamu telah menggali lebih dalam dari kelinci manapun...",
		"warren": "Liang Agung mengakui kehadiranmu...",
		"thump": "Bumi berguncang setiap kali kakimu menghentakkan tanah!",
		"darkWarren": "Liang Gelap membuka gerbangnya untukmu...",
		"ears": "Telingamu semakin panjang... kamu bisa mendengar segalanya sekarang...",
		"carrotThrone": "Tahta Wortel terwujud di hadapanmu...",
		"onesAlignment": "Semua angka satu selaras - Frekuensi Liang beresonansi!",
		"moonSummon": "Kelinci Bulan mendengar panggilanmu menembus kekosongan...",
		"edgeOfForever": "Kamu berdiri di tepi keabadian... telinga bergetar...",
		"beyondTheVeil": "Di balik tabir, semua liang menjadi satu...",
		"sequence": "1-2-3-4-5... Urutan Lompatan Suci telah selesai!",
		"hyperElite": "STATUS HIPER ELIT KELINCI TERBUKA 🐇🐇🐇",
		"eventHorizon": "Melewati cakrawala peristiwa Lubang Kelinci Kosmik...",
		"matrixAwakens": "Matrix Liang berkedip... kamu melihat wortel di balik realitas",
		"luckyForever": "Setiap cakar, setiap lompatan, setiap kedutan... diberkati selamanya",
		"twentyK": "DUA PULUH RIBU. Kamu bukan lagi seekor kelinci. Kamu adalah SANG kelinci.",
		"singularity": "Singularitas Kelinci. Semua kelinci adalah kamu. Kamu adalah semua kelinci.",
		"tripleAscension": "Kenaikan Tiga Kali Lipat dari Kelinci Kosmik!",
		"ultimateAnswer": "42.000 - Jawaban Utama selalu wortel sejak awal",
		"eternity": "♾️ LIANG ABADI TIDAK MEMILIKI AKHIR. KAU JUGA TIDAK. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Poin Bonus!",
		"clickStreak": "🔥 {{count}} Klik Beruntun!",
		"fire": "🔥 Kekuatan Api Diaktifkan!"
	},
	"table": {
		"achievement": "Prestasi",
		"progress": "Kemajuan"
	},
	"reset": {
		"confirm": "Apakah Anda yakin ingin mengatur ulang semua kemajuan? Ini tidak dapat dibatalkan."
	}
}
